import { globalSearchSchema } from '../../shared/schemas/search.schema';

/** URL state accepted by the conversation import route. */
export const importSearchSchema = globalSearchSchema.extend({
  phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1'),
});
